import {khanFetch} from "@khan/data-fetch";
import {Errors, KAError} from "@khan/logging";

/**
 * speechToText makes a request to the speech-to-text endpoint to transcribe audio
 * to text. It returns the transcription result.
 */
export const speechToText = async (audio: Blob): Promise<string> => {
    try {
        const resp = await khanFetch(
            "/api/internal/_ai-guide/speech-to-text/",
            {
                method: "POST",
                body: audio,
            },
        );

        if (!resp.ok || !resp.body) {
            throw new KAError(
                "speechToText request failed",
                Errors.KhanService,
            );
        }

        const {transcript} = await resp.json();
        return transcript;
    } catch (err: unknown) {
        // We handle the exception thrown from within the mutation success
        // handler.
        if (err instanceof KAError) {
            throw err;
        }

        // Otherwise we throw a generic error.
        throw new KAError(
            "an error occurred during a request to speechToText",
            Errors.Internal,
            {cause: err instanceof Error ? err : String(err)},
        );
    }
};
